import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../componentsLegacy/Header";
import BarraApp from "../componentsPeopletech/Barraaps"; // Asegúrate de que sea el nombre correcto
import Footer from "../componentsLegacy/Footer/Footer";

const HomeLegacy = () => {
  const baseUrl = "https://www.peoplefortech.com";
  const pageUrl = `${baseUrl}/legacy/home`;

  return (
    <>
      <Helmet>
        <title>Legacy - PeopleForTech</title>
        <meta name="description" content="Legacy page for internal/archived content." />
        <meta name="robots" content="noindex,follow" />
        <link rel="canonical" href={pageUrl} />
      </Helmet>
      <BarraApp />
      <Header /> {/* Componente de encabezado */}
      <Footer />
    </>
  );
};

export default HomeLegacy;
